import "./App.css";
import Header from "./Header";
import Overlay from "./Overlay";
import React, { useState } from "react";
import Banner from "./Banner";
import Services from "./Services";
import Projects from "./Projects";
import Contact from "./Contact";
import { Switch, Route } from "react-router";
import About from "./About";
import MediaLink from "./MediaLink";
import Articles from "./Articles";

function App() {
  const [overlay, setOverlay] = useState("overlay");

  return (
    <div className="App">
      <Switch>
        <Route path="/articles" exact>
          <Header setOverlay={setOverlay} />
          <Overlay overlay={overlay} />
          <Articles setOverlay={setOverlay} />
        </Route>
        <Route path="/about" exact>
          <Header setOverlay={setOverlay} />
          <Overlay overlay={overlay} />
          <About />
        </Route>
        <Route path="/" exact>
          <Header setOverlay={setOverlay} />
          <Overlay overlay={overlay} />
          <MediaLink />
          <Banner />
          <Services />
          <Projects />
          <Contact />
        </Route>
      </Switch>
    </div>
  );
}

export default App;
